import { useShrinkContext } from "../context/ShrinkContext";
import CardList from "./CardList";
import SideListMenu from "./SideListMenu";

export default function Sidebar() {
  const [state] = useShrinkContext();
  return (
    <div
      className={
        state.shrink
          ? " nav-shrink translate-x-full effect-transition"
          : "nav-shrink effect-transition z-50"
      }
    >
      <SideListMenu />
      <CardList />
    </div>
  );
}
